import api from '~/services/api';
import PropTypes from 'prop-types';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'permissionsgroups';

// GET
export const getPermissionsGroups = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createPermissionsGroups = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updatePermissionsGroups = async (route = '', values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${route}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deletePermissionsGroups = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data.data;
  } catch (error) {
    throw error;
  }
};

getPermissionsGroups.propTypes = {
  params: PropTypes.object.isRequired,
};

createPermissionsGroups.propTypes = {
  values: PropTypes.object.isRequired,
};

updatePermissionsGroups.propTypes = {
  values: PropTypes.object.isRequired,
};

deletePermissionsGroups.propTypes = {
  id: PropTypes.string.isRequired,
};
